import get from 'lodash/get';

import getServiceLocation from '@/lib/getServiceLocation';
import { getAuthenticatedFetchJSON } from './fetch';

const fetchVehicles = (injectedFetch = fetch) => {
    const configuredFetch = getAuthenticatedFetchJSON(injectedFetch);

    return configuredFetch(`${getServiceLocation('assetsApi')}/assets?status=active`)
        .then((res) => get(res, 'items', []))
        .catch(() => []);
};

export default fetchVehicles;
